import React, { useCallback, useState } from 'react';
import { createTheme } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import RadioIcon from '@material-ui/icons/Radio';
import Slide from '@material-ui/core/Slide';

import EditGroupPresentationModal from './EditGroupPresentationModal';

import {
  Button,
  Card,
  Grid,
  CardContent,
  Divider,
  makeStyles
} from '@material-ui/core';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const defaultTheme = createTheme();

const useStyles = makeStyles((theme) => ({
  cardElement: {
    width: '100%',
    height: '500px',
    border: '1px solid gray'
  },
  dialogModalContent: {
    padding: '24px'
  },
  radioIcon: {
    fontSize: '50px',
    marginRight: '5px'
  },
  unitDetails:{
    display: 'grid'
  },
  unitContainer: {
    display: 'flex'
  },
  editTag: {
    marginLeft: '5px',
    color: '#0099CC',
    cursor: 'pointer'
  }
}));

export default function AlertDialogSlide({ modalShow, modalState, id }) {
  const classes = useStyles();
  const [open, setOpen] = useState(modalShow);
  const [isEditGroupPresentationModalOpen, setIsEditGroupPresentationModalOpen] = useState(false);
  const [row, setRow] = useState([]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClickEditTag = () => {
    setOpen(false);
    setIsEditGroupPresentationModalOpen(true);
  };

  const handleClose = () => {
    modalState(false);
    // setOpen(false);
  };

  const [editRowsModel, setEditRowsModel] = useState({});

  const handleEditRowsModelChange = useCallback((model) => {
    setEditRowsModel(model);
  }, []);

  return (
    <div>
      <Button variant="outlined" onClick={handleClickOpen}></Button>
      <Dialog
        disableBackdropClick={true}
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description">
        <DialogTitle className="dialog-modal-title" id="alert-dialog-slide-title">Group 00-00_1080p (1) Properties</DialogTitle>
        <DialogContent className={classes.dialogModalContent}>
          <Grid container item justify="center" lg={12} xs={12} md={12}>
            <span style={{ width: '100%', marginBottom: '20px' }}>Presentations</span>
            <Card className={classes.cardElement} justify="center" cot>
              <CardContent className="card-content">
                <Divider />
                <div className={classes.unitContainer}>
                  <div>
                    <RadioIcon className={classes.radioIcon} />
                  </div>
                  <div className={classes.unitDetails}>
                    <div>
                      <span>C_ALL_Thisen4Prez_v1</span>
                      <span className={classes.editTag} onClick={handleClickEditTag}>edit</span>
                    </div>
                    <span>Every Day at 12:00 AM - 12:00 AM</span>
                  </div>
                </div>
              </CardContent>
            </Card>
          </Grid>
        </DialogContent>
        <DialogActions className="dialog-modal-action">
          <div>
            <Button variant="contained" color="default" onClick={handleClose} >
              Close
            </Button>
            <Button className="color-changer" variant="contained" style={{ marginLeft: '10px' }} onClick={handleClose} >
              Add
            </Button>
          </div>
        </DialogActions>
      </Dialog>
      {isEditGroupPresentationModalOpen ? (
        <EditGroupPresentationModal modalShow={isEditGroupPresentationModalOpen} modalState={setIsEditGroupPresentationModalOpen} />
      ) : ''}
    </div>
  );
}